<template>
  <div v-if="detailData" class="pt-10 px-20">
    <div v-if="detailData.pic && detailData.pic.length">
      <img class="w-full mb-12" v-for="(item, index) in detailData.pic" :key="index" :src="item.photo_thumb_file" alt />
    </div>
    <div class="text-18 text-default">{{ detailData.title }}</div>
    <div class="flex text-14 text-gray mt-10">
      {{ detailData.author }}:
      {{ detailData.start_time_name }}
    </div>
    <div class="content mt-15 text-16 text-default leading-24" v-html="detailData.content"></div>
    <div>
      <!-- <div class="my-progress" v-if="progress > 0">
        <div class="my-progress-child" :style="{ width: progress + '%' }"></div>
        <div class="parent">{{ progress }}%</div>
      </div> -->
      <!-- <button v-if="detailData.files && detailData.files != undefined && !mask" @click="mask = true">
        附件{{ detailData.files.length }}
      </button> -->
    </div>
    <!-- <div class="enclosur-model fadeIn" v-if="mask">
        <div class="enclosur-model-t">
          <div class="look">点击下载/查看</div>
          <div
            class="item"
            v-for="(item, index) in detailData.files"
            :key="index"
            @click="downloadfile(detailData.files)"
          >
            附件{{ index + 1 }}
          </div>
        </div>
        <div class="enclosur-model-b fadeOut" @click="mask = false">取消</div>
      </div> -->
  </div>
</template>
<script setup>
import { ref } from "vue";
import { noticeService } from "@/service";
import to from "await-to-js";
import { useRoute } from "vue-router";
import { vLoading } from "@/utils/loading";

const route = useRoute();

const detailData = ref(null);

const downloadfile = url => {
  // eslint-disable-next-line no-undef
  wx.miniProgram.navigateTo({
    url: `/pages/download/main?url=${url}&type=pdf&action=0`
  });
};

const getDetail = async () => {
  vLoading.start();
  const [error, result] = await to(noticeService.announcement_detail({ id: route.query.id }));
  if (error) return;
  vLoading.stop();
  detailData.value = result.data.data;
};
getDetail();
</script>
<style scoped>
.content :deep(*) {
  font-size: 16px;
  color: #2c3746;
}
:deep(ol, ul) {
  margin-top: 5px;
  margin-left: 30px !important;
  list-style: auto !important;
}
:deep(p, h6) {
  margin-top: 5px;
}
</style>
